/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "../../components/BaseCom";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import L from "../../components/Lang";
import { Link } from "react-router-dom";
import FormInput from "../../components/FormInput";
import { qreq } from "../../shared/qrequest";

class LoginModal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    async componentDidMount() {
        await this.getSettings();
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    submit = async (e) => {
        e?.preventDefault();
        try {
            let j = await qreq.postAsync('/api/auth/login', this.state.info);
            if (j.errorCode === 0) {
                if(j.item.flags.indexOf('admin') >= 0)
                    window.location.assign('/admin');
                else
                    window.location.assign('/dashboard/home');
                this.props.onHide();
            }
            else
                this.warn(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header>
                <Modal.Title>
                    <L>Welcome to the {this.state.SETTINGS?.appName}</L>
                    <p style={{ fontWeight: 'normal' }}><L>New here?</L> <span role="button" className="text-primary" onClick={this.props.onSignUp}>Create an Account</span></p>
                </Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <FormInput model={this.state.info} name="email" label="Username / Email" type="text" onChange={this.change} />
                    <FormInput model={this.state.info} name="password" label="Password" type="password" onChange={this.change} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success"><L>Sign In</L></button>
                    <span role="button" className="btn" onClick={this.props.onForgot}>Forgot Password</span>
                    <p>
                        <L>By creating an account, you agree to our</L>
                        {this.state.SETTINGS?.tosLink && <a href={this.state.SETTINGS?.tosLink} target="_blank" rel="noreferrer"> <L>Terms of Service</L></a>}
                    </p>
                </Modal.Footer>
            </form>
        </Modal>
    }
}

export default withParamsAndNavigate(LoginModal);